<template>
  <div>
    <div class="cleax">
      <button class="btn1 fl">
        <router-link to="/">返回商城首页</router-link>
      </button>
      <!-- <button class="btn1 fl">
        <router-link rel="opener" target="_blank" :to="{ path: '/mingjue' }"
          >重新查询</router-link
        >
      </button> -->
      <button @click="fanhui" class="btn2 fl">
        重新查询
      </button>
    </div>

    <iframe
      id="iframe1"
      width="100%"
      height="800px"
      :src="
        `https://plugin.dataenlighten.com/chuangpei/#/?token=${this.cipher.token}&uuid=${this.cipher.uuid}&eventId=${this.cipher.eventId}&productCode=${this.cipher.productCode}`
      "
      frameborder="0"
    ></iframe>
    <!-- &vin=${this.cipher.vin}&mjsid==${this.cipher.mjsid}  跳转页面是这个的 -->
  </div>
</template>

<script>
import { getErp } from '../../../api/home'
export default {
  data() {
    return {
      cipher: {
        uuid: '',
        eventId: '',
        productCode: '',
        token: '',
        vin: '',
        mjsid: ''
      },
      getdata: {},
      osde: '',
      ceshi: []
    }
  },
  created() {
    this.skip()
  },
  // watch: {
  //   postmessage(a, b) {
  //     console.log(a, b)
  //   }
  // },
  methods: {
    async skip() {
      const res = await getErp()
      console.log(res)
      if (res.status) {
        this.cipher = res.data
        let receiveMessage = e => {
          if (e.data.message.parts) {
            // this.getdata = JSON.stringify(e.data.message)
            this.getdata = JSON.parse(JSON.stringify(e.data.message.parts))
            console.log(this.getdata)
            for (let index = 0; index < this.getdata.length; index++) {
              const element = this.getdata[index]
              console.log(element)
              for (let index = 0; index < element.sysOeCode.length; index++) {
                var element1 = element.sysOeCode[index]
                this.ceshi.push(element1)
              }
            }
            console.log(this.ceshi)
            this.ceshi = this.ceshi.join(',')
            console.log(this.ceshi)
            this.$router.push({
              path: '/partsSearch',
              query: { searchContent: this.ceshi }
            })
            // console.log(this.$route.query(searchContent))
            // 清除监听事件的
            // window.removeEventListener('message', receiveMessage, true)
          } else {
            return false
          }
          console.log(e)
        }
        window.addEventListener('message', receiveMessage, true)
      }
    },
    fanhui() {
      // var HL = window.history.length
      // console.log(HL)
      window.history.go(0)
      // window.loaction.reload()
      // this.$router.go(0)
    }
  }
}
</script>

<style lang="less" scoped>
body {
  overflow-y: hidden;
}
.cleax::after {
  content: '';
  display: block;
  height: 0;
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.btn1 {
  width: 150px;
  height: 50px;
  font-size: 20px;
  font-weight: bold;
  margin: 10px 20px;
  background-color: #fff;
  border: 2px solid #e90d0d;
  padding: 3px;
  margin-right: 20px;
  .router-link-active {
    color: #ff0000;
  }
}
.btn2 {
  width: 150px;
  height: 50px;
  font-size: 20px;
  font-weight: bold;
  margin: 10px 20px;
  color: #e90d0d;
  background-color: #fff;
  border: 2px solid #e90d0d;
  padding: 3px;
  margin-right: 20px;
}
</style>
